import React, { useState, useEffect } from 'react'
import { useHistory, NavLink } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { isOpenResortModalSelector } from '../../redux/selectors'
import {hideHelperAction, logoutAction, meAction} from '../../redux/actions/auth'
import {
  closeResortModal,
  openDrawInstruments,
} from '../../redux/actions/modalsActions'
import { makeStyles } from '@material-ui/core/styles'
import LogoutSharpIcon from '@material-ui/icons/ExitToAppSharp'
import { Button } from '@material-ui/core/'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import ModalWindowWrapper from './ModalWindowWrapper'
import LoginContent from './ModalWindowWrapper/content/LoginContent'
import SignContent from './ModalWindowWrapper/content/SignContent'
import ForgotContent from './ModalWindowWrapper/content/ForgotContent'
import ResortContent from './ModalWindowWrapper/content/ResortContent'
import ResetPasswordModal from './ModalWindowWrapper/content/ResetPassword'
import style from './Header.module.scss'
import LoggedUserInfo from './LoggedUserInfo'
import { countriesArrayAction } from '../../redux/actions/resort'

const useStyles = makeStyles(() => ({
  root: {
    color: '#e3e4ef',
    marginRight: '5px',
    textTransform: 'capitalize',
    fontSize: '22px',
    fontWeight: 600,
    fontFamily: "'Bebas Neue', cursive",
  },
  extraPadding:{
    marginLeft: '0px'
  }
}))

const Header = (props) => {
  const [showLogout, setShowLogout] = useState(false)

  let location = useLocation()

  const classes = useStyles()
  const history = useHistory()

  const isOpenResort = useSelector((state) => isOpenResortModalSelector(state))
  const dispatch = useDispatch()

  const [isMapPage, setMapPage] = useState(false)

  const [isOpenLogin, setLoginModal] = useState(false)
  const [isOpenSign, setSignModal] = useState(false)
  const [isOpenForgot, setForgotModal] = useState(false)

  useEffect(() => {
    if (
      localStorage.getItem('access_token') &&
      props.me &&
      Object.keys(props.me).length <= 0
    ) {
      props.meAction()
    }
  }, [])

  useEffect(() => {
    countriesArrayAction()
  }, [])

  useEffect(() => {
    if (
      isOpenLogin ||
      isOpenSign ||
      window.location.pathname === '/password/reset' ||
      isOpenResort ||
      isOpenForgot
    ) {
      document.getElementById('root').classList.add('show')
      const scrollY = document.documentElement.style.getPropertyValue(
        '--scroll-y',
      )
      const body = document.body
      // body.style.position = 'fixed';
      // body.style.top = `-${scrollY}`;
      body.style.overflow = 'hidden'
    } else {
      const body = document.body
      const scrollY = body.style.top
      // body.style.position = '';
      // body.style.top = '';
      body.style.overflow = ''
      // window.scrollTo(0, parseInt(scrollY || '0') * -1);
      document.getElementById('root').classList.remove('show')
    }
  }, [isOpenLogin, isOpenSign, location, isOpenResort, isOpenForgot])

  useEffect(() => {
    const { pathname } = history.location
    if (pathname !== '/') {
      setMapPage(true)
    }

    if (pathname === '/password/reset') {
      setMapPage(false)
    }
  }, [history])

  useEffect(() => {
    if (location.state && location.state.loginIsopen) {
      setLoginModal(true)
      history.replace({
        pathname: '',
        state: {},
      })
    }
  }, [location.state, history])

  // Methods
  const closeLoginModal = () => {
    setLoginModal(false)
  }

  const closeSignModal = () => {
    setSignModal(false)
  }

  const closeForgotModal = () => {
    setForgotModal(false)
  }

  const handleCloseResortModal = () => {
    dispatch(closeResortModal())
  }

  const handleOpenDraw = () => {
    dispatch(openDrawInstruments())
  }

  const onOpenForgotModal = () => {
    setLoginModal(false)
    setForgotModal(true)
  }

  const backToLogin = () => {
    handleCloseResortModal()
    setForgotModal(false)
    setSignModal(false)
    setLoginModal(true)
  }

  const backToSignUp = () => {
    setLoginModal(false)
    setSignModal(true)
  }

  // Render diffirent modal content
  const renderLoginModal = isOpenLogin ? (
    <ModalWindowWrapper
      closeModal={closeLoginModal}
      title={'Login'}
      content={
        <LoginContent
          backToSignUp={backToSignUp}
          onOpenForgotModal={onOpenForgotModal}
          onCLose={closeLoginModal}
        />
      }
      onClose={closeLoginModal}
    />
  ) : null

  const renderSignModal = isOpenSign ? (
    <ModalWindowWrapper
      title={'Sign Up'}
      content={
        <SignContent onClose={closeSignModal} backToLogin={backToLogin} />
      }
      onClose={closeSignModal}
    />
  ) : null

  const rendeResetPasswordModal =
    window.location.pathname === '/password/reset' ? (
      <ModalWindowWrapper
        title={'Reset Password'}
        content={<ResetPasswordModal backToLogin={backToLogin} />}
        onClose={closeSignModal}
      />
    ) : null
  const renderForgotModal = isOpenForgot ? (
    <ModalWindowWrapper
      title={'Reset Password'}
      content={
        <ForgotContent
          closeModal={closeForgotModal}
          backToLogin={backToLogin}
        />
      }
      onClose={closeForgotModal}
    />
  ) : null

  // Modals requests from other DOM node button click, that's why used flag from redux
  const renderResortModal = isOpenResort ? (
    <ModalWindowWrapper
      title={'Please, select all fields'}
      content={
        <ResortContent
          onClose={handleCloseResortModal}
          backToLogin={backToLogin}
        />
      }
      onClose={handleCloseResortModal}
    />
  ) : null

  // Render different UI and functionality for header witch depends on current route.
  const renderEditButton =
    isMapPage && window.location.pathname !== '/password/reset' ? (
      <Button className={classes.root} onClick={handleOpenDraw}>
        Edit map
      </Button>
    ) : null

  const resortNameTrimmer = (text) => {
    let isMobile = checkIsMobile();
    let maxLength = 16; 

    if (props.me && Object.keys(props.me).length > 0) {
      maxLength = 20; 
    }

    if (text.length < maxLength || !isMobile) return text;

    return text.slice(0, maxLength - 3) + '...';
  }


  const checkIsMobile = () => {
    let getSize = window.innerWidth;
    if (getSize < 468) {
      return true
    }
    return false
  }

  let renderBreadcrumbs = null;

  if (isMapPage && window.location.pathname !== '/password/reset') {
    const resort = (props?.match?.params?.resort ?? '').replaceAll('-', ' ');
    renderBreadcrumbs = (
      <div className={style.breadcrumbs}>
        <NavLink className={style.navLink} to="/">
          Home /
        </NavLink>
        {resort && (
          <div className={style.resortName} title={resort}>
            {resort}
          </div>
        )}
      </div>
    );
  }
  const headerStyle = !isMapPage
    ? 'header'
    : window.location.pathname === '/password/reset'
    ? 'header'
    : 'headerMap'

  const logoutHandler = () => {
    props.hideHelperAction(false);
    props.logoutAction()
    props.history.push('/')
  }

  const displayHandler = (data) => {
    setShowLogout(!showLogout)
  }

  const handleClose = () => {
    setShowLogout(false)
  }

  const headerButtons =
    props.me && Object.keys(props.me).length > 0 ? (
      <React.Fragment>
        <LoggedUserInfo
          showLogout={showLogout}
          handleClose={handleClose}
          displayHandler={displayHandler}
          logoutHandler={logoutHandler}
        />
        <div className={style.logoutContainer}>
          <LogoutSharpIcon className={style.Logout} onClick={logoutHandler} />
        </div>
      </React.Fragment>
    ) : (
      <React.Fragment>
        {' '}
        <Button className={`${classes.root} ${classes.extraPadding}`} onClick={() => setLoginModal(true)}>
          Login
        </Button>
        <Button className={classes.root} onClick={() => setSignModal(true)}>
          Sign Up
        </Button>
      </React.Fragment>
    )
  const marginLeftValue = props.me && Object.keys(props.me).length > 0 ? 17 : 7;

  return (
    <>
      <header className={style[headerStyle]}>
        {renderBreadcrumbs}
        <div className={`${style.btnGroup} custom-class`} style={{ marginLeft: `${marginLeftValue}px` }}>
         {/*{renderEditButton} */}
          {headerButtons}
        </div>
      </header>
      {rendeResetPasswordModal}
      {renderLoginModal}
      {renderSignModal}
      {renderForgotModal}
      {renderResortModal}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    me: state.auth.me,
    resort: state.crumbs,
  }
}

const mapDispatchToProps = {
  logoutAction,
  countriesArrayAction,
  meAction,
  hideHelperAction,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))
